import { render, staticRenderFns } from "./couponCodeTable.vue?vue&type=template&id=48001ab0&scoped=true"
import script from "./couponCodeTable.vue?vue&type=script&lang=js"
export * from "./couponCodeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48001ab0",
  null
  
)

export default component.exports